import React, { Component } from 'react';
import { connect } from 'react-redux';
import Node from './Node'
import Loading from '../fixedComponents/Loading'
import { fetchNodes, setInitialPosition, fetchNodesMineLiked } from '../../actions';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export class NodeId extends Component {

  componentWillMount() {
    let { id, client, server, fetchNodes, fetchNodesMineLiked } = this.props
    if(server.fetch[id] !== true){
      fetchNodes(id, (client.rootNumber + 1))
      if(cookies.get('api_access_token') === 'undefined' || cookies.get('api_access_token') == null) {
        return
      }
      fetchNodesMineLiked(id);
    }
  };

  componentDidMount() {
    let { id, server, setInitialPosition } = this.props
    if(!server.fetch[id]) {
      setInitialPosition(window.innerHeight, window.innerWidth, '-1')
    }
  };

  render() {
    const { id, server, client } = this.props
    if(typeof server.contents[id] === 'undefined') {
      return <Loading />
    }
    return (
      <div>
        <Node id={this.props.server.rootId} page={0}
          number={String(client.rootNumber)} parent={String(client.rootNumber)} root={true} />
      </div>
    )
  }
}

const mapDispatchToProps = {
  fetchNodes,
  fetchNodesMineLiked,
  setInitialPosition
}

const mapStateToProps = state => ({
  server: state.server,
  client: state.client
});

export default connect(mapStateToProps, mapDispatchToProps)(NodeId)



// WEBPACK FOOTER //
// ./src/components/nodes/NodeId.js